import http from '../http';
import Qs from 'qs';

// 查询学生服务签约协议记录-分页
const getServiceSigningList = (params) =>
  http
    .get('/theUserIdentity/sysSignStudent/studentServiceSigningAgreementPage', {
      params
    })
    .then((res) => res.data);
// 查询学生服务签约协议记录-导出
const studentServiceSigningAgreementExport = (params) =>
  http
    .get(
      '/theUserIdentity/sysSignStudent/studentServiceSigningAgreementExport',
      {
        params,
        responseType: 'blob'
      }
    )
    .then((res) => res);
// 查询学生服务签约协议记录-导出
const pushMsgToParentReSign = (params) =>
  http
    .get('/theUserIdentity/sysSignStudent/pushMsgToParentReSign', {
      params
    })
    .then((res) => res);
// 服务协议模板-分页查询
const getServiceAgreementTemplatePage = (params) =>
  http
    .get(
      '/theUserIdentity/serviceAgreementTemplate/serviceAgreementTemplatePage',
      {
        params
      }
    )
    .then((res) => res.data);

// 服务协议模板-分页查询
const deleteServiceAgreementTemplate = (params) =>
  http
    .get(
      '/theUserIdentity/serviceAgreementTemplate/deleteServiceAgreementTemplate',
      {
        params
      }
    )
    .then((res) => res.data);
// 获取静态参数配置列表
const getByCodeType = (params) =>
  http
    .get('/theUserIdentity/sysStaticDatas/getByCodeType', {
      params
    })
    .then((res) => res.data);

// 添加服务协议模板
const addServiceAgreementTemplate = (params) =>
  http
    .post(
      '/theUserIdentity/serviceAgreementTemplate/addServiceAgreementTemplate',
      params,
      {
        headers: { 'Content-Type': 'application/json' }
      }
    )
    .then((res) => res.data);
// 获取教育局关联的单位
const getEduRelOrg = (params) =>
  http
    .get('/theUserIdentity/common/eduRelOrg', {
      params
    })
    .then((res) => res.data);
// 服务协议模板-详情查询
const getServiceAgreementTemplateDetail = (params) =>
  http
    .get(
      '/theUserIdentity/serviceAgreementTemplate/serviceAgreementTemplateDetail',
      {
        params
      }
    )
    .then((res) => res.data);
// 获取学校关联的单位
const getSchoolRelOrg = (params) =>
  http
    .get('/theUserIdentity/common/schoolRelOrg', {
      params
    })
    .then((res) => res.data);
// 服务协议模板-导出
const serviceAgreementTemplateExport = (params) =>
  http
    .get(
      '/theUserIdentity/serviceAgreementTemplate/serviceAgreementTemplateExport',
      {
        params,
        responseType: 'blob'
      }
    )
    .then((res) => res);

// 编辑服务协议模板
const editServiceAgreementTemplate = (params) =>
  http
    .post(
      '/theUserIdentity/serviceAgreementTemplate/updateServiceAgreementTemplate',
      params,
      {
        headers: { 'Content-Type': 'application/json' }
      }
    )
    .then((res) => res.data);
// 获取学校关联的单位
const getDefaultTemplate = (params) =>
  http
    .get(
      '/theUserIdentity/serviceAgreementTemplate/serviceSigningAgreementDefaultTemplate',
      {
        params
      }
    )
    .then((res) => res.data);

// 批量修改服务协议模板配置
const batchUpdateAgreementTemplate = (params) =>
  http
    .post(
      '/theUserIdentity/serviceAgreementTemplate/batchUpdateServiceAgreementTemplate',
      params,
      {
        headers: { 'Content-Type': 'application/json' }
      }
    )
    .then((res) => res.data);
// 将pdf文件id和单位关联
const saveFileIdRelOrg = (params) =>
  http
    .post(
      '/theUserIdentity/serviceAgreementTemplate/saveFileIdRelOrg',
      Qs.stringify(params),
      {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      }
    )
    .then((res) => res.data);
// 将pdf文件id和学校关联
const saveFileIdRelSchool = (params) =>
  http
    .post(
      '/theUserIdentity/serviceAgreementTemplate/saveFileIdRelSchool',
      Qs.stringify(params),
      {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      }
    )
    .then((res) => res.data);
// 将pdf文件id和平台关联
const saveFileIdRelPlat = (params) =>
  http
    .post(
      '/theUserIdentity/serviceAgreementTemplate/saveFileIdRelPlat',
      Qs.stringify(params),
      {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      }
    )
    .then((res) => res.data);

// 删除单位和pdf文件关联
const deleteFileIdRelOrg = (params) =>
  http
    .get('/theUserIdentity/serviceAgreementTemplate/deleteFileIdRelOrg', {
      params
    })
    .then((res) => res.data);
// 删除配置完成文件（删除配置编辑域pdf文件）
const deleteFinalFile = (params) =>
  http
    .get('/theUserIdentity/serviceAgreementTemplate/deleteFinalFile', {
      params
    })
    .then((res) => res.data);

// 将pdf文件id和编辑域文件关联
const saveFinalFileIdRelAgreement = (params) =>
  http
    .post(
      '/theUserIdentity/serviceAgreementTemplate/saveFinalFileIdRelAgreement',
      Qs.stringify(params),
      {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      }
    )
    .then((res) => res.data);

// 更新编辑域配置状态
const updateConfigSts = (params) =>
  http
    .get('/theUserIdentity/serviceAgreementTemplate/updateConfigSts', {
      params
    })
    .then((res) => res.data);

// 服务协议预览（纯文本）
const getServiceAgreementTemplate = (params) =>
  http
    .post(
      '/theUserIdentity/serviceAgreementTemplate/getServiceAgreementTemplate',
      params,
      {
        headers: { 'Content-Type': 'application/json' }
      }
    )
    .then((res) => res.data);

// 获取服务协议pdf预览文件token
const getPreviewServicePdftoken = (params) =>
  http
    .get('/file/previewServicePdf/token', {
      params
    })
    .then((res) => res.data);
// 获取服务协议pdf下载token
const getDownServicePdftoken = (params) =>
  http({
    method: 'post',
    url: '/file/downServicePdf/token',
    data: params,
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  }).then((res) => res.data);

// 获取服务协议模板pdf上传文件token
const getUploadServiceTemplatePdfApi = (params) =>
  http
    .get('/file/uploadServiceTemplatePdf/token', {
      params
    })
    .then((res) => res.data);

// 获取服务协议模板pdf预览文件token
const getPreviewServiceTemplatePdfApi = (params) =>
  http
    .get('/file/previewServiceTemplatePdf/token', {
      params
    })
    .then((res) => res.data);

// 获取服务协议模板pdf下载文件token

const getDownServiceTemplatePdfApi = params =>
  http({
    method: 'post',
    url: '/file/downServiceTemplatePdf/token',
    data: params,
    headers: { 'Content-Type': 'application/json;charset=UTF-8' }
  }).then(res => res.data);

export default {
  getServiceSigningList,
  studentServiceSigningAgreementExport,
  pushMsgToParentReSign,
  getServiceAgreementTemplatePage,
  deleteServiceAgreementTemplate,
  getByCodeType,
  addServiceAgreementTemplate,
  getEduRelOrg,
  getServiceAgreementTemplateDetail,
  getSchoolRelOrg,
  serviceAgreementTemplateExport,
  editServiceAgreementTemplate,
  getDefaultTemplate,
  batchUpdateAgreementTemplate,
  saveFileIdRelOrg,
  saveFileIdRelSchool,
  saveFileIdRelPlat,
  deleteFileIdRelOrg,
  deleteFinalFile,
  saveFinalFileIdRelAgreement,
  updateConfigSts,
  getServiceAgreementTemplate,
  getPreviewServicePdftoken,
  getDownServicePdftoken,
  getUploadServiceTemplatePdfApi,
  getPreviewServiceTemplatePdfApi,
  getDownServiceTemplatePdfApi
};
